<div class="primary-router-outlet">
  <router-outlet></router-outlet>
</div>